import { useField } from 'formik';
import { useState } from 'react';

import { Combobox } from '../../../components/combobox/Combobox';
import { InputWrapper } from '../../../components/InputWrapper';
import { MinimalPurchase as MinimalPurchaseModel, useMinimalPurchases } from '../models';

export type MinimalPurchase = MinimalPurchaseModel;

export interface IMinimalPurchaseComboboxFieldProps {
  name: string;
  labelText?: string;
  helperText?: string;
  isDisabled?: boolean;
}

export function MinimalPurchaseComboboxField(props: IMinimalPurchaseComboboxFieldProps) {
  const { name, labelText = 'Aankoopfactuur', helperText, isDisabled } = props;
  const [searchValue, setSearchValue] = useState('');
  const { data } = useMinimalPurchases(searchValue, 50);

  const purchases: MinimalPurchase[] = data ?? [];
  const [field, meta, helpers] = useField({ name });
  const selectedItem = field.value ?? null;

  return (
    <InputWrapper labelText={labelText} invalidText={meta.touched ? meta.error : undefined} helperText={helperText}>
      <Combobox
        keyName="id"
        placeholder="Selecteer een aankoopfactuur"
        onQueryChange={setSearchValue}
        display={(val: MinimalPurchase) => `${val.invoiceNumber} (${val.supplier.name})`}
        items={purchases}
        selectedItem={selectedItem}
        onSelect={helpers.setValue}
        onBlur={() => helpers.setTouched(true)}
        isDisabled={isDisabled}
        isInvalid={Boolean(meta.touched && meta.error)}
        isNullable={true}
      />
    </InputWrapper>
  );
}
